<template>
  <div class="my-2">
    <template v-if="selectedFlag">
      <div class="cursor-pointer vs-con-loading__container" id="request-btn-loading">
        <div class="available-action flex px-4 py-2" @click="requestPickup()">
          <feather-icon icon="TruckIcon" svgClasses="w-4 h-4" class="self-center"/>
          <span class="text-sm ml-2">{{$route.name === 'merchant-returns-view' ? $t('Request Return') : $route.name === 'merchant-cash-collections-view'? $t('Collect Request') :  $t('Request Pickup')}}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select the order you want to request!')}`">
        <div class="cursor-not-allowed">
          <div class="pointer-events-none unavailable-action flex px-4 py-2">
            <feather-icon icon="TruckIcon" svgClasses="w-4 h-4" class="self-center"/>
            <span class="text-sm ml-2">{{$route.name === 'merchant-returns-view' ? $t('Request Return') : $route.name === 'merchant-cash-collections-view'? $t('Collect Request') :  $t('Request Pickup')}}</span>
          </div>
        </div>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import common from '../../../assets/utils/common.js'
import {sendRequest} from '../../../http/axios/requestHelper.js'
export default {
  props: ['selected'],
  data () {
    return {
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0 && val.filter(item => item.status === 'created' || item.status === 'pickup_rescheduled').length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    requestPickup () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#request-btn-loading',
        scale: 0.45
      })
      const trackings = []
      let url = ''
      this.selected.forEach(element => {
        if (element.status === 'created' || element.status === 'pickup_rescheduled') {
          if (this.$route.name === 'merchant-cash-collections-view') {
            url = 'api/v1/tracking/cash-collections/'
            trackings.push({
              cash_collection_request:element.id,
              status: 'collection_requested'
            })
          } else {
            url = 'api/v1/tracking/'
            trackings.push({
              order:element.id,
              status: this.$route.name === 'merchant-returns-view' ? 'return_requested' : 'pickup_requested'
            })
          }
        }
        if (this.$route.name === 'merchant-cash-collections-view') {
          url = 'api/v1/tracking/cash-collections/'
        }
      })
      sendRequest(true, false, this, url, 'post', trackings, true,
        () => {
          this.$vs.loading.close('#request-btn-loading > .con-vs-loading')
          this.$emit('loadShipments')
          this.$emit('selected', [])
        },
        (error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close('#request-btn-loading > .con-vs-loading')
        }
      )
    }
  }
}
</script>